
  import { RequiredConfigVariable } from '@/services/integrations/types';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Button } from '@/ui/components/Button';
  import { InputField } from '@/ui/components/form/InputField';
  import BaseStep, { BaseStepProperties, BASE_STEP_PROPS } from './BaseStep.vue';
  import { defineComponent, ref } from 'vue';

  interface DropdownStepProperties extends BaseStepProperties {
    configVariable: RequiredConfigVariable;
  }

  export default defineComponent<DropdownStepProperties>({
    components: {
      InputField,
      Button,
      BaseStep,
    },
    props: [...BASE_STEP_PROPS, 'configVariable'],

    setup(props) {
      const { key } = props.configVariable;
      const store = useIntegrationDetailsStore();
      const input = props.configVariable.connection.inputs.nodes.find(input => input.key === 'database');
      if (!input) {
        throw new Error('Database input not found');
      }

      const value = ref(store.getConnectionConfigVariable(key, 'database'));
      const placeholder = input.comments;

      const submit = () => {
        if (!value.value) {
          return;
        }

        store.setConnectionConfigVariable(key, input.key, value.value!);
        store.nextStep();
      };

      return {
        value,
        placeholder,
        submit,
      };
    },
  });
